import { CONTACT_NAMES } from 'store/patients';

export const NAMES = CONTACT_NAMES.reduce((acc, { id, title }) => {
  acc[id] = title;

  return acc;
}, {});
